import RaikoGridOneColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridOneColumn";
import {SliderService} from "../../serverService/sliderService/SliderService";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {useState} from "react";
import {css} from "@emotion/css";
import RaikoSimpleInputOutlined from "../../raikoComponents/raikoCustomInput/RaikoSimpleInputOutlined";
import RaikoSimpleMultiLineInputOutlined
    from "../../raikoComponents/raikoCustomInput/RaikoSimpleMultiLineInputOutlined";
import ButtonDivisionSection from "../../component/ButtonDivisionSection/ButtonDivisionSection";
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";

export default function SliderAddNewItem(
    {
        sliderId,
        handleCloseDialog = () => {
        },
        handleAddItem = () => {
        }
    }) {

    const service = new SliderService()
    const snackbar = new SnackbarHelper(useSnackbarDispatcher())
    const loading = new LoadingHelper(useLoadingDispatcher())

    const [title, setTitle] = useState("");
    const [shortDescription, setShortDescription] = useState("");
    const [link, setLink] = useState("");

    function handleAddNewSliderItem() {
        if (checkFields()) {
            loading.show()
            service.addNewSliderItem(sliderId, title, shortDescription, link)
                .then(response => {
                    handleAddItem(response)
                    handleCloseDialog()
                    snackbar.showSuccessMessage("اسلاید جدید با موفقیت افزوده شد.")
                    loading.hide()
                }).catch(reason => {
                snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در ساخت اسلاید جدید."))
                loading.hide()
            })
        }
    }

    function checkFields() {
        let state = false
        let message = ""

        if (title.length === 0) {
            message = "لطفا عنوان خبر را وارد نمایید."
        } else if (link.length === 0) {
            message = "لطفا لینک مقصد خبر را وارد نمایید."
        } else if (shortDescription.length === 0) {
            message = "لطفا توضیحات کوتاه خبر را وارد نمایید."
        } else {
            state = true
        }

        snackbar.showWarningMessage(message)
        return state
    }

    return (
        <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem`}>
            <RaikoSimpleInputOutlined
                labelText={"عنوان"}
                setValue={setTitle}
                value={title}/>

            <RaikoSimpleInputOutlined
                labelText={"لینک مقصد"}
                setValue={setLink}
                value={link}/>

            <RaikoSimpleMultiLineInputOutlined
                labelText={"توضیحات کوتاه"}
                setValue={setShortDescription}
                value={shortDescription}/>
            <ButtonDivisionSection>
                <ButtonPrimaryRaiko label={"افزودن"} onClick={handleAddNewSliderItem}/>
            </ButtonDivisionSection>
        </RaikoGridOneColumn>
    )
}